"use strict";
/*
 * Created on 19. 9. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var PriceComment_1 = require("../model/PriceComment");

var PriceCommentConverter_1 = require("./PriceCommentConverter");
/**
 * Default implementation of {@link PriceCommentConverter}
 *
 * @author JMr
 */


var PriceCommentConverterImpl =
/*#__PURE__*/
function (_PriceCommentConverte) {
  _inherits(PriceCommentConverterImpl, _PriceCommentConverte);

  function PriceCommentConverterImpl() {
    _classCallCheck(this, PriceCommentConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceCommentConverterImpl).apply(this, arguments));
  }

  _createClass(PriceCommentConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      // Comments that are not persistent or not persistent yet (stored in release items), have empty id
      return new PriceComment_1.PriceComment((utils_1.Utils.isValueMissing(source.id) || utils_1.Utils.VOID_ID === source.id) && utils_1.Utils.isValueMissing(source._id) ? utils_1.Utils.VOID_ID : PriceComment_1.PriceComment.schema.id.valueOf(conversions.documentToClassId(source)), PriceComment_1.PriceComment.schema.releaseId.valueOf(conversions.toClassReferenceId(source.releaseId)), utils_1.Utils.isValueMissing(source.priceZoneId) ? null : PriceComment_1.PriceComment.schema.priceZoneId.valueOf(conversions.toClassReferenceId(source.priceZoneId)), PriceComment_1.PriceComment.schema.userId.valueOfField(source), source.username ? PriceComment_1.PriceComment.schema.username.valueOfField(source) : null, PriceComment_1.PriceComment.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), PriceComment_1.PriceComment.schema.text.valueOfField(source), PriceComment_1.PriceComment.schema.persistent.valueOfField(source), source.deleteOn ? conversions.toDate(source.deleteOn) : null);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      // Comments that are not persistent or not persistent yet (stored in release items), have empty id
      var document = {};
      Object.assign(document, !source.persistent ? {
        id: utils_1.Utils.VOID_ID
      } : conversions.classToDocumentId(source));
      Object.assign(document, {
        releaseId: conversions.toDocumentReferenceId(source.releaseId),
        priceZoneId: source.priceZoneId !== null ? conversions.toDocumentReferenceId(source.priceZoneId) : null,
        userId: source.userId,
        username: source.username,
        productId: conversions.toDocumentReferenceId(source.productId),
        text: source.text,
        persistent: source.persistent,
        deleteOn: source.deleteOn ? conversions.fromDate(source.deleteOn) : null
      });
      return document;
    }
  }]);

  return PriceCommentConverterImpl;
}(PriceCommentConverter_1.PriceCommentConverter);

exports.PriceCommentConverterImpl = PriceCommentConverterImpl;